import { type MutableRefObject, useMemo, useRef } from 'react';
import type { TableProps } from '@timeedit/ui-components/antd';
import { useTableDimensions } from './useDimensions';

export const useDefaultTableProps = <T extends { id: string | number }>(
  heightMargin: number = 50,
  rowKey = 'id'
): [
  MutableRefObject<HTMLDivElement>,
  Pick<TableProps<T>, 'scroll' | 'virtual' | 'pagination' | 'rowKey' | 'size'>,
  number,
] => {
  const contentRef = useRef<HTMLDivElement>(null);
  const { height: tableHeight, width: tableWidth } =
    useTableDimensions(contentRef);

  const scroll = useMemo(() => {
    return { x: tableWidth || 700, y: tableHeight - heightMargin || 300 };
  }, [tableHeight, tableWidth, heightMargin]);

  return [
    contentRef,
    {
      scroll,
      virtual: true,
      pagination: false,
      rowKey,
      size: 'small',
    },
    tableHeight,
  ];
};
